function getDeliveryDate() {
  const daysOfWeek = ["dom", "lun", "mar", "miér", "jue", "vie", "sáb"];
  const monthsOfYear = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

  // Lista de feriados (puedes editar según tu país o reglas)
  const holidays = (year) => [
    luxon.DateTime.fromObject({ year, month: 1, day: 1 }),   // Año Nuevo
    luxon.DateTime.fromObject({ year, month: 12, day: 24 }),  // Navidad
    luxon.DateTime.fromObject({ year, month: 12, day: 25 }),  // Navidad
    luxon.DateTime.fromObject({ year, month: 12, day: 31 })  // Navidad
  ];

  const isHoliday = (date) => {
    const year = date.getFullYear();
    const luxonDate = luxon.DateTime.fromJSDate(date).startOf('day');
    return holidays(year).some(holiday => holiday.hasSame(luxonDate, 'day'));
  };

  const getNextBusinessDay = (date) => {
    let nextDate = new Date(date);
    while (
      nextDate.getDay() === 0 || // Domingo
      //nextDate.getDay() === 6 || // Sábado
      isHoliday(nextDate)
    ) {
      nextDate.setDate(nextDate.getDate() + 1);
    }
    return nextDate;
  };

  // Obteniendo fecha y hora actual en zona horaria de México
  let today = luxon.DateTime.now().setZone('America/Mexico_City').toISO();
  //let today = luxon.DateTime.fromObject({ year: 2025, month: 7, day: 7, hour: 11, minute: 59 })
  today = new Date(today);

  const currentHour = today.getHours();
  const currentMinutes = today.getMinutes();
  const currentDay = today.getDay(); // 0 = domingo, 1 = lunes, ..., 6 = sábado

  let deliveryDate = new Date(today);

  if (currentDay >= 1 && currentDay <= 4) { // Lunes a Jueves
    if (currentHour < 15 || (currentHour === 15 && currentMinutes === 0)) {
      deliveryDate.setDate(today.getDate() + 1);
    } else {
      deliveryDate.setDate(today.getDate() + 2);
    }
  }

  if (currentDay === 5) { // Viernes
    if (currentHour < 17 || (currentHour === 17 && currentMinutes === 0)) {
      deliveryDate.setDate(today.getDate() + 1); // Antes de 5:00pm
    } else {
      deliveryDate.setDate(today.getDate() + 3); // Después de 5:00pm
    }
  }

  if (currentDay === 6) { // Sábado
    deliveryDate.setDate(today.getDate() + 2);
  }

  if (currentDay === 0) { // Domingo
    deliveryDate.setDate(today.getDate() + 1);
  }

  // NUEVO: Ajustar si cae en feriado o fin de semana
  deliveryDate = getNextBusinessDay(deliveryDate);

  // Comparar para saber si es hoy o mañana
  const isToday = deliveryDate.toDateString() === today.toDateString();

  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const isTomorrow = deliveryDate.toDateString() === tomorrow.toDateString();

  if (isToday) {
    return "hoy";
  } else if (isTomorrow) {
    return "mañana";
  } else {
    const dayName = daysOfWeek[deliveryDate.getDay()];
    const monthName = monthsOfYear[deliveryDate.getMonth()];
    const day = deliveryDate.getDate();
    return `${dayName} ${day} ${monthName}`;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const dateElement = document.getElementById('date__estimated');
  if (dateElement) {
    let date = getDeliveryDate();
    dateElement.textContent = date;
  }
});
